import {validateCpfCnpj} from "../../../utils/validate-cpf-cnpj/validate-cpf-cnpj"
import {parseDate} from "../../../utils/validate-date/parse-date"

export const evaluateSectionValidity = ({sectionName, keys, state, fieldsMap}) => {
    let hasEmpty = false
    let hasError = false

    const fields = fieldsMap[sectionName] || []

    keys.forEach((key) => {
        const value = state[key]
        const fieldDef = fields.find((f) => f.key === key)
        const isRequired = fieldDef?.required === true
        const isEmpty = value === undefined || value === null || (typeof value === "string" && value.trim() === "")

        if (isRequired && isEmpty) {
            hasEmpty = true
            return
        }

        if (!isRequired && isEmpty) {
            return
        }

        const naoCadastrado = state[`${key}NaoCadastrado`]
        if (naoCadastrado) {
            hasError = true
            return
        }

        if (fieldDef?.maskType === "date" && value) {
            if (`${value}`.length < 10) {
                hasError = true
                return
            }
            const date = parseDate(value)
            if (!date) {
                hasError = true
                return
            }
            if (fieldDef.minDate) {
                const min = parseDate(fieldDef.minDate)
                if (min && date < min) {
                    hasError = true
                }
            }
            if (fieldDef.maxDate) {
                const max = parseDate(fieldDef.maxDate)
                if (max && date > max) hasError = true
            }
        }

        const isEmpresasAutoComplete = (fieldDef?.type === "autoComplete" || fieldDef?.type === "empresasAutoComplete") &&
            fieldDef?.autoCompleteSource === "empresas"
        if (fieldDef?.maskType === "cpfCnpj" && value && !isEmpresasAutoComplete) {
            const digitsLength = `${value}`.replace(/\D/g, "").length
            if (digitsLength < 11) {
                hasError = true
                return
            }
            if (!validateCpfCnpj(value)) {
                hasError = true
            }
        }
    })

    if (hasError || hasEmpty) return false
    return true
}

export const getInvalidFields = ({sectionName, keys, state, fieldsMap}) => {
    const invalidLabels = []
    const fields = fieldsMap[sectionName] || []

    keys.forEach((key) => {
        const value = state[key]
        const fieldDef = fields.find((f) => f.key === key)
        const isRequired = fieldDef?.required === true

        // Verifica se está "vazio" (Aceita 0 como válido)
        const isEmpty = value === undefined || value === null || (typeof value === "string" && value.trim() === "")

        // 1. Obrigatório e Vazio
        if (isRequired && isEmpty) {
            invalidLabels.push(fieldDef.label)
            return
        }

        // 2. Opcional e Vazio (Pula validação)
        if (!isRequired && isEmpty) {
            return
        }

        // 3. Validações Específicas (Se der erro, adiciona na lista)
        const naoCadastrado = state[`${key}NaoCadastrado`]
        if (naoCadastrado) {
            invalidLabels.push(fieldDef.label)
            return
        }

        if (fieldDef?.maskType === "date" && value) {
            let dateError = false
            if (`${value}`.length < 10) dateError = true
            else {
                const date = parseDate(value)
                if (!date) dateError = true
                else {
                    if (fieldDef.minDate) {
                        const min = parseDate(fieldDef.minDate)
                        if (min && date < min) dateError = true
                    }
                    if (fieldDef.maxDate) {
                        const max = parseDate(fieldDef.maxDate)
                        if (max && date > max) dateError = true
                    }
                }
            }
            if (dateError) {
                invalidLabels.push(fieldDef.label)
                return
            }
        }

        const isEmpresasAutoComplete = (fieldDef?.type === "autoComplete" || fieldDef?.type === "empresasAutoComplete") && fieldDef?.autoCompleteSource === "empresas"
        
        if (fieldDef?.maskType === "cpfCnpj" && value && !isEmpresasAutoComplete) {
            const digitsLength = `${value}`.replace(/\D/g, "").length
            if (digitsLength < 11 || !validateCpfCnpj(value)) {
                invalidLabels.push(fieldDef.label)
            }
        }
    })

    return invalidLabels
}
